const checkDevice = (size,limit) => {
    let isMobile = false;
    if (size < limit) {
        isMobile = true;
    } else {
        isMobile = false;
    }
    return isMobile;
}
export default checkDevice;